"use client";

import { ItemAvatar, ItemContent, ItemSide, ItemTitle, List, Spinner } from "@opensea/ui-kit";
import { OpenInNew } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { Item } from "../../../../../components/Item";
import { CUSTOM_PRIVY_CONNECTORS, useConnectors } from "../../../../../polychain/hooks/useConnectors";
import { useUninstalledWalletOptions } from "./useUninstalledWalletOptions";
export function MoreWalletOptions({
  switchOnConnect,
  connect
}) {
  const uninstalledWalletOptions = useUninstalledWalletOptions();
  const {
    getConnector
  } = useConnectors();
  const [connectingWalletId, setConnectingWalletId] = useState();
  const handleWalletClick = async walletOption => {
    // Check if this is a Privy connector (Glyph or VeeFriends)
    const isPrivyConnector = CUSTOM_PRIVY_CONNECTORS.has(walletOption.id);
    if (isPrivyConnector) {
      const connector = getConnector(walletOption.id);
      if (connector) {
        setConnectingWalletId(walletOption.id);
        try {
          await connect(connector, {
            switchOnConnect
          });
        } finally {
          setConnectingWalletId(undefined);
        }
      }
    }
  };
  return <List className="overflow-hidden rounded-xl bg-bg-primary">
      {uninstalledWalletOptions.map(walletOption_0 => {
      const isPrivyConnector_0 = CUSTOM_PRIVY_CONNECTORS.has(walletOption_0.id);
      return <Item className="focus-visible:outline-hidden" disabled={connectingWalletId === walletOption_0.id} href={isPrivyConnector_0 ? undefined : walletOption_0.href} key={walletOption_0.id} onClick={isPrivyConnector_0 ? () => {
        handleWalletClick(walletOption_0);
      } : undefined}>
            {walletOption_0.icon && <ItemAvatar src={walletOption_0.icon} />}
            <ItemContent>
              <ItemTitle className="w-full truncate text-start">
                {walletOption_0.name}
              </ItemTitle>
            </ItemContent>
            <ItemSide>
              {connectingWalletId === walletOption_0.id ? <Spinner size="xs" /> : !isPrivyConnector_0 && <OpenInNew size={16} />}
            </ItemSide>
          </Item>;
    })}
    </List>;
}